import styled from 'styled-components';
import Drawer from '../Drawer';
import { Text } from '@/shared/Typography';

export const StyledDeleteDrawer = styled(Drawer)``;

export const ItemsText = styled(Text)`
  display: flex;
  gap: 5px;
  align-items: center;
`;
